<div class="container">
  <div class="title">
    <div class="logo"></div>
    <h1>{{'sign_in.title' | translate}}</h1>
  </div>
  <div class="center">
    <form *ngIf="showForm" @fadeInToRight (@fadeInToRight.done)="fadeContent = 'show'" [formGroup]="loginGroup"
          class="form mat-elevation-z2">

      <div *ngIf="isLoading" class="loading-layout">
        <div class="spinner-layout">
          <mat-spinner [diameter]="30"></mat-spinner>
        </div>
      </div>

      <div [@fadeContent]="fadeContent" (@fadeContent.done)="doneFadeContent()" class="header m-b-15">
        <div class="logo"></div>
        <div class="context">
          <h3>{{'sign_in.sign_in' | translate}}</h3>
        </div>
      </div>

      <mat-form-field [@fadeContent]="fadeContent" color="accent" appearance="outline">
        <mat-label>{{'sign_in.username' | translate}}</mat-label>
        <input formControlName="name" matInput type="text" placeholder="{{'sign_in.username' | translate}}" required>
      </mat-form-field>

      <mat-form-field [@fadeContent]="fadeContent" color="accent" appearance="outline">
        <mat-label>{{'sign_in.pwd' | translate}}</mat-label>
        <input formControlName="password" matInput [type]="passwordVisibility ? 'text' : 'password'"
               placeholder="{{'sign_in.pwd' | translate}}" required>

        <mat-icon style="cursor: pointer" matSuffix (click)="togglePasswordVisibility()">{{passwordVisibility ?
          'visibility_off' : 'visibility'}}
        </mat-icon>

      </mat-form-field>
      <mat-checkbox [@fadeContent]="fadeContent" formControlName="remember">{{'sign_in.remember' | translate}}</mat-checkbox>
      <button [@fadeContent]="fadeContent" [disabled]="loginGroup.invalid || isLoading" color="accent" (click)="login()"
              mat-raised-button>{{'sign_in.sign' | translate}}
      </button>
    </form>

  </div>
</div>
